import { SEX_TYPE } from './category';

export const MEMBER_TYPES_REGISTER = {
  NULL: 0,
  MEN: 1,
  WOMEN: 2,
  COUPLES: 4,
  GROUPS: 8,
  COUPLES_FF: 16,
  COUPLES_MM: 32,
  TV_CD: 64,
  TRANS_WOMAN: 128,
  TRANS_MAN: 256,
};

export const GROUP_SINGLE_OR_COUPLES = {
  SINGLE: 0,
  COUPLE: 4,
  COUPLE_FF: 16,
  COUPLE_MM: 32,
};

export const MEMBER_TYPE_GROUPS = {
  [MEMBER_TYPES_REGISTER.MEN]: GROUP_SINGLE_OR_COUPLES.SINGLE,
  [MEMBER_TYPES_REGISTER.WOMEN]: GROUP_SINGLE_OR_COUPLES.SINGLE,
  [MEMBER_TYPES_REGISTER.TV_CD]: GROUP_SINGLE_OR_COUPLES.SINGLE,
  [MEMBER_TYPES_REGISTER.TRANS_WOMAN]: GROUP_SINGLE_OR_COUPLES.SINGLE,
  [MEMBER_TYPES_REGISTER.TRANS_MAN]: GROUP_SINGLE_OR_COUPLES.SINGLE,
  [MEMBER_TYPES_REGISTER.GROUPS]: GROUP_SINGLE_OR_COUPLES.SINGLE,

  [MEMBER_TYPES_REGISTER.COUPLES]: GROUP_SINGLE_OR_COUPLES.COUPLE,
  [MEMBER_TYPES_REGISTER.COUPLES_FF]: GROUP_SINGLE_OR_COUPLES.COUPLE_FF,
  [MEMBER_TYPES_REGISTER.COUPLES_MM]: GROUP_SINGLE_OR_COUPLES.COUPLE_MM,
};
